import * as UpdateCompanyTypes from 'src/actions/company/update/Types';
import { UpdateCompanyAction } from 'src/actions/company/update/UpdateCompany.actions';

export interface UpdateCompanyState {
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: UpdateCompanyState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function UpdateCompanyReducer(state: UpdateCompanyState = initialState,
                                     action: UpdateCompanyAction): UpdateCompanyState {
  switch (action.type) {
    case UpdateCompanyTypes.UPDATE_COMPANY_ATTEMPT:
      return {...state, loading: true, error: false};
    case UpdateCompanyTypes.UPDATE_COMPANY_SUCCESS:
      return {...state, loading: false, error: false};
    case UpdateCompanyTypes.UPDATE_COMPANY_FAILURE:
      return {...state, loading: false, error: true, errorMessage: action.payload};
    case UpdateCompanyTypes.UPDATE_COMPANY_CLEAR_ERRORS:
      return { ...state, loading: false, error: false, errorMessage: {} };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/company/UpdateCompanyReducer.tsx